module.exports = __webpack_public_path__ + "img/Poratil + portillon.ccc07014.jpg";